// fetchCountries.js
import { message } from "antd";
import { selectBaseUrl, selectProdTestUrl } from "../../redux/slices/envSlice";

export const fetchCities = async (setStates, baseUrl, prodTestUrl) => {
  try {
    const response = await fetch(
      `${prodTestUrl ? prodTestUrl : baseUrl}/api/admin-get-all-city/`
    );
    if (response.ok) {
      const data = await response.json();
      setStates(data);
    } else {
      message.error("Failed to fetch cities.");
    }
  } catch (error) {
    message.error("An error occurred while fetching cities.");
  }
};